import { render } from "./ListUnbilled.vue?vue&type=template&id=1d3b6d5e"
import script from "./ListUnbilled.vue?vue&type=script&lang=js"
export * from "./ListUnbilled.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__